import { Typography } from '@mui/material';

function PageHeader() {

  return (
    <>
      <Typography variant="h3" component="h3" gutterBottom>
        All Chapters
      </Typography>
      <Typography variant="subtitle2">
        All Chapters of LumaPOS
      </Typography>
    </>
  );
}

export default PageHeader;